import { useState } from "react";
import { subscribeNewsletter } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, ArrowRight } from "lucide-react";
import { Overline } from "@/components/site/Reveal";

export default function NewsletterSignup({ compact = false }) {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error("Please enter your email.");
      return;
    }
    try {
      setLoading(true);
      await subscribeNewsletter({ email, name: name || null });
      toast.success("You're on the list — thank you! 💗");
      setEmail("");
      setName("");
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="newsletter-signup"
      className="rounded-3xl border border-border bg-muted/50 px-8 py-12 md:px-14 md:py-14"
    >
      <div className="grid lg:grid-cols-12 gap-8 items-center">
        <div className="lg:col-span-6">
          <Overline>The Newsletter</Overline>
          <h3 className="mt-4 font-serif text-3xl md:text-4xl font-light leading-tight">
            Thoughts worth keeping, in your inbox.
          </h3>
          <p className="mt-3 text-muted-foreground leading-relaxed max-w-md">
            Occasional notes on leadership, behavioral science, and building a life
            you love. No noise — just what matters.
          </p>
        </div>
        <form onSubmit={submit} className="lg:col-span-6 space-y-5">
          <div className="grid sm:grid-cols-2 gap-5">
            <input
              data-testid="newsletter-name"
              className="field-underline"
              placeholder="First name (optional)"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <input
              data-testid="newsletter-email"
              type="email"
              className="field-underline"
              placeholder="you@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <button
            type="submit"
            data-testid="newsletter-submit"
            disabled={loading}
            className="group inline-flex items-center gap-2 rounded-full bg-primary px-8 py-4 text-sm uppercase tracking-[0.18em] font-medium text-primary-foreground transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_40px_-15px_rgba(193,119,103,0.6)] disabled:opacity-60"
          >
            {loading ? (
              <Loader2 className="h-4 w-4 animate-spin" strokeWidth={1.5} />
            ) : (
              <>
                Subscribe
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" strokeWidth={1.5} />
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
}
